import React, {useState, useEffect} from 'react';
import { gql, useQuery } from '@apollo/client';
import DataTable from '@preflighttech/preflight-tables';
import { View, Text, Pressable } from 'react-native';
import {
  UNHIDE_SELLER
} from './Sellers/queries';
import {
  UNHIDE_VENDOR
} from './Vendors/queries';
import {
  UNHIDE_USER
} from './Users/AuctionUsers/queries';
import {
  UNHIDE_SELLER_USER
} from './Users/SellerUsers/queries';
import {
  UNHIDE_CONTACT
} from './Contacts/queries';
import {
  UNHIDE_BUYER
} from './Buyers/queries';
import { UNHIDE_BUYER_USER } from './Users/BuyerUsers/queries';
import {
  UNHIDE_LOCATION
} from './Locations/queries';
import {
  UNHIDE_PADDLE_SERVICE
} from './PaddleServices/queries';
import {
  UNHIDE_PRE_BID_SCHEDULE
} from './PreBidSchedules/queries';

import { UNHIDE_ACCOUNT } from './Accounting/Accounts/queries';
import { UNHIDE_ACCOUNT_GROUP } from './Accounting/AccountGroups/queries';
import { UNHIDE_FEE_TYPE } from './Accounting/FeeTypes/queries';
import { UNHIDE_PAYMENT_TERM } from './Accounting/PaymentTerms/queries';

import { useMutation } from '@apollo/client';
import {
  MainContainer,
  ContentContainer,
  LinkContainer,
  PageTitle,
  TableContainer,
  TabButtonContainer,
  InactiveResourceTabButton,
  TabText
} from '../elements';
import Modal from '../elements/Modal';
import Filter from 'app/src/elements/Filter';
import { ResetSettings } from 'app/src/elements/Pagination/ResetSettings';

const INACTIVE_RESOURCES = gql`
  query InactiveResources {
    inactiveResources {
      buyers {id, name, buyerUsers { email }}
      buyerUsers {id, fullName, email, buyer { name }}
      contacts {id, fullName, seller { name }}
      locations {id, address}
      paddleServices {id, name}
      preBidSchedules {id, name}
      sellers {id, name}
      sellerUsers {id, fullName, seller { name }}
      users {id, fullName}
      vendors {id, name}
      accounts {id, name}
      accountGroups {id, name}
      feeTypes {id, name}
      paymentTerms {id, name}
    }
  }
`;

const inputStyle = {
  marginBottom: '10px'
}

const InactiveResources = () => {
  const [clickedUser, setClickedUser] = useState();
  const [resources, setResources] = useState([]);
  const [showEditUserModal, setShowEditUserModal] = useState(false);
  const [filterOptions, setFilterOptions] = useState();
  const [filters, setFilters] = useState({});
  const [settings, setSettings] = useState({});
  const [activeTab, setActiveTab] = useState('Buyers')
  const queryVariables = {
    filterColumns: [],
    filterNames: [],
    scopes: [],
  };

  const { loading, error, data, refetch } = useQuery(
    INACTIVE_RESOURCES, { }
  );

  const [unHideBuyer] = useMutation(UNHIDE_BUYER, { onCompleted: refetch })
  const [unHideBuyerUser] = useMutation(
    UNHIDE_BUYER_USER, { onCompleted: refetch }
  );
  const [unHideContact] = useMutation(UNHIDE_CONTACT, { onCompleted: refetch })
  const [unHideLocation] = useMutation(UNHIDE_LOCATION, { onCompleted: refetch })
  const [unHidePaddleService] = useMutation(UNHIDE_PADDLE_SERVICE, { onCompleted: refetch })
  const [unHidePreBidSchedule] = useMutation(
    UNHIDE_PRE_BID_SCHEDULE, { onCompleted: refetch }
  );
  const [unHideSeller] = useMutation(UNHIDE_SELLER, { onCompleted: refetch })
  const [unHideSellerUser] = useMutation(UNHIDE_SELLER_USER, { onCompleted: refetch })
  const [unHideUser] = useMutation(UNHIDE_USER, { onCompleted: refetch })
  const [unHideVendor] = useMutation(UNHIDE_VENDOR, { onCompleted: refetch })

  const [unHideAccount] = useMutation(UNHIDE_ACCOUNT, { onCompleted: refetch });
  const [unHideAccountGroup] = useMutation(
    UNHIDE_ACCOUNT_GROUP, { onCompleted: refetch }
  );
  const [unHideFeeType] = useMutation(
    UNHIDE_FEE_TYPE, { onCompleted: refetch }
  );
  const [unHidePaymentTerm] = useMutation(
    UNHIDE_PAYMENT_TERM, { onCompleted: refetch }
  );

  useEffect(() => {
    setResources(data?.inactiveResources)
  }, [data])

  if(loading || !resources) {

    return null
  }

  const onUnhide = (resource) => {
    if(window.confirm(`Make ${getName(resource)} Active?`)) {
      switch(resource.__typename) {
        case 'Buyer':
          unHideBuyer({ variables: { id: resource.id }});
          break;
        case 'BuyerUser':
          unHideBuyerUser({ variables: { id: resource.id }});
          break;
        case 'Contact':
          unHideContact({ variables: { id: resource.id }});
          break;
        case 'Location':
          unHideLocation({ variables: { id: resource.id }});
          break;
        case 'PaddleService':
          unHidePaddleService({ variables: { id: resource.id }});
          break;
        case 'PreBidSchedule':
          unHidePreBidSchedule({ variables: { id: resource.id }});
          break;
        case 'Seller':
          unHideSeller({ variables: { id: resource.id }});
          break;
        case 'SellerUser':
          unHideSellerUser({ variables: { id: resource.id }});
          break;
        case 'User':
          unHideUser({ variables: { id: resource.id }});
          break;
        case 'Vendor':
          unHideVendor({ variables: { id: resource.id }});
          break;
        case 'Account':
          unHideAccount({ variables: { id: resource.id }});
          break;
        case 'AccountGroup':
          unHideAccountGroup({ variables: { id: resource.id }});
          break;
        case 'FeeType':
          unHideFeeType({ variables: { id: resource.id }});
          break;
        case 'PaymentTerm':
          unHidePaymentTerm({ variables: { id: resource.id }});
          break;
        default:
          break;
      }
    }
  };

  const setFilter = (key, value) => {
    const currentFilters = {...filters};
    currentFilters[key] = value;
    setFilters(currentFilters);
  }

  Object.entries(filters).forEach(([key, value]) => {
    if (value) {
      queryVariables.filterColumns.push(key);
      queryVariables.filterNames.push(value);
    }
  });

  const columns = [
    {
      key: 'name',
      label: 'Resource Name',
      sort: 'asc',
      content: (entry) => getName(entry.entry)
    },
    {
      key: 'typename',
      label: 'Resource Type',
      // width: '20%',
      content: (entry) => {
        return entry.entry.__typename
      }
    },
    {
      key: 'functions',
      label: 'Functions',
      // width: '15%',
      // minViewportWidth: 1000,
      sort: 'prevent',
      content: (entry) => {
        return (
          <View style={{display: 'inline-flex'}}>
            <LinkContainer>
              <Pressable
                onPress={() => onUnhide(entry.entry)}
              >
                UnHide
              </Pressable>
            </LinkContainer>
          </View>
        )
      }
    }
  ]

  if ('Buyers' === activeTab) {
    columns.splice(2, 0,
      {
        key: 'buyerUsers',
        label: 'Buyer User Emails',
        value: ({ value }) => value.map(buyerUser => buyerUser.email).join(', ')
      }
    )
  }

  if ('BuyerUsers' === activeTab) {
    columns.splice(2, 0,
      {
        key: 'email',
        label: 'Email',
      }
    );

    columns.splice(2, 0,
      {
        key: 'buyer',
        label: 'Buyer',
        value: ({ value }) => value?.name,
      }
    );
  }

  if(['Contacts', 'SellerUsers'].includes(activeTab)) {
    columns.splice(2, 0,
      {
        key: 'sellerName',
        label: 'Seller',
        content: (entry) => {
          return entry.entry.seller?.name
        }
      }
    )
  }

  const buttons = (
    <View style={{display: 'flex', flexDirection: 'row'}}>
      <Filter
        clearFilters={() => {
          setFilters({})
          setShowModal(false)
        }}
        filters={filters}
        setFilters={setFilters}
      >

      </Filter>
      <ResetSettings />
    </View>
  );

  return (
    <MainContainer>
      <ContentContainer>
        <PageTitle>Inactive Resources</PageTitle>
        <br /><br />
        <TabButtonContainer>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Buyers')}
            active={'Buyers' === activeTab}
          >
            <TabText active={'Buyers' === activeTab}>
              {`Buyers (${resources.buyers?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('BuyerUsers')}
            active={'BuyerUsers' === activeTab}
          >
            <TabText active={'BuyerUsers' === activeTab}>
              {`Buyer Users (${resources.buyerUsers?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Contacts')}
            active={'Contacts' === activeTab}
          >
            <TabText active={'Contacts' === activeTab}>
              {`Contacts (${resources.contacts?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Locations')}
            active={'Locations' === activeTab}
          >
            <TabText active={'Locations' === activeTab}>
              {`Locations (${resources.locations?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('PaddleServices')}
            active={'PaddleServices' === activeTab}
          >
            <TabText active={'PaddleServices' === activeTab}>
              {`Paddle Services (${resources.paddleServices?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('PreBidSchedules')}
            active={'PreBidSchedules' === activeTab}
          >
            <TabText active={'PreBidSchedules' === activeTab}>
              {`Pre Bid Schedules (${resources.preBidSchedules?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Sellers')}
            active={'Sellers' === activeTab}
          >
            <TabText active={'Sellers' === activeTab}>
              {`Sellers (${resources.sellers?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('SellerUsers')}
            active={'SellerUsers' === activeTab}
          >
            <TabText active={'SellerUsers' === activeTab}>
              {`Seller Users (${resources.sellerUsers?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Users')}
            active={'Users' === activeTab}
          >
            <TabText active={'Users' === activeTab}>
              {`Users (${resources.users?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('Vendors')}
            active={'Vendors' === activeTab}
          >
            <TabText active={'Vendors' === activeTab}>
              {`Vendors (${resources.vendors?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>

          <InactiveResourceTabButton
            onPress={() => setActiveTab('Accounts')}
            active={'Accounts' === activeTab}
          >
            <TabText active={'Accounts' === activeTab}>
              {`Accounts (${resources.accounts?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('AccountGroups')}
            active={'AccountGroups' === activeTab}
          >
            <TabText active={'AccountGroups' === activeTab}>
              {`Account Groups (${resources.accountGroups?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('FeeTypes')}
            active={'FeeTypes' === activeTab}
          >
            <TabText active={'FeeTypes' === activeTab}>
              {`Fee Types (${resources.feeTypes?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
          <InactiveResourceTabButton
            onPress={() => setActiveTab('PaymentTerms')}
            active={'PaymentTerms' === activeTab}
          >
            <TabText active={'PaymentTerms' === activeTab}>
              {`Payment Terms (${resources.paymentTerms?.length || 0})`}
            </TabText>
          </InactiveResourceTabButton>
        </TabButtonContainer>
        <TableContainer>
          {getActiveTabbedContent()}
        </TableContainer>
      </ContentContainer>
    </MainContainer>
  )

  function getName(resource) {
    if ('Location' == resource.__typename) {
      return resource.address;
    }

    return [
      'BuyerUser', 'Contact', 'User', 'SellerUser'
    ].includes(resource.__typename) ? resource.fullName : resource.name
  }

  function getResources() {
    switch(activeTab) {
      case 'Buyers':
        return resources.buyers
        break;
      case 'BuyerUsers':
        return resources.buyerUsers
        break;
      case 'Contacts':
        return resources.contacts
        break;
      case 'Locations':
        return resources.locations
        break;
      case 'PaddleServices':
        return resources.paddleServices
        break;
      case 'PreBidSchedules':
        return resources.preBidSchedules
        break;
      case 'Sellers':
        return resources.sellers
        break;
      case 'SellerUsers':
        return resources.sellerUsers
        break;
      case 'Users':
        return resources.users
        break;
      case 'Vendors':
        return resources.vendors
        break;
      case 'Accounts':
        return resources.accounts
        break;
      case 'AccountGroups':
        return resources.accountGroups
        break;
      case 'PaymentTerms':
        return resources.paymentTerms
        break;
      case 'FeeTypes':
        return resources.feeTypes
        break;
      default:
        break;
    }
  }

  function getActiveTabbedContent() {
    return <DataTable.Simple
      data={getResources()}
      columns={columns}
      pageLength="All"
    />
  }
}

export default InactiveResources;
